<template>
<!--  <RequestCallForm></RequestCallForm>-->
  <DataSubjectRequestForm></DataSubjectRequestForm>
<!--    <AnotherForm request-path="https://www.starwindsoftware.com/request-g2-v23.js">-->

<!--        <template v-slot:thankyou>-->
<!--            <div class="thank-page" >-->
<!--                <p>Thank you for your interest!</p>-->
<!--                <p>The report has been sent to your email address.</p>-->
<!--            </div>-->
<!--        </template>-->

<!--    </AnotherForm>-->
<!--    <ResourceLibrary>-->
<!--        <template v-slot:thankyou>-->
<!--            <div class="thank-page" >-->
<!--                <p>Thank you for your interest!</p>-->
<!--                <p>The report has been sent to your email address.</p>-->
<!--            </div>-->
<!--        </template>-->
<!--    </ResourceLibrary>-->
</template>

<script>
// import RequestCallForm from "./components/RequestCallForm.vue";
import DataSubjectRequestForm from "./components/DataSubjectRequestForm.vue";
// import AnotherForm from "./components/AnotherForm.vue";
// import ResourceLibrary from "./components/ResourceLibrary.vue";
export default {
  name: "App",
  components: {
    DataSubjectRequestForm,
    //   AnotherForm,
    //   ResourceLibrary
  },
};
</script>

<style>
</style>
